import {
  getCountdownExpirationDatetime,
  getShowCountdown,
  hasQuizOnboardingData,
  useDescriptionModal,
} from '../helpers';

import { Countdown } from './Countdown.js';
import { NudgeModal } from './NudgeModal/index.js';

const getStrings = (user) => ({
  heading: `Your ${
    hasQuizOnboardingData(user) ? 'personalized ' : ''
  }plan has been reserved for the next 15 minutes!`,
});

/**
 *
 * @param {object} props
 * @param {string|Date} props.fromDate
 * @param {object} props.user
 * @returns {JSX.Element}
 */
export function OfferCountdown({ fromDate, user }) {
  const countdownExpireDatetime = getCountdownExpirationDatetime(fromDate);
  const showCountdown = getShowCountdown(fromDate);
  const { hide, show, visible } = useDescriptionModal();

  return (
    <>
      {showCountdown && (
        <Countdown
          strings={getStrings(user)}
          toDate={countdownExpireDatetime}
          onZero={show}
        />
      )}
      <NudgeModal onClose={hide} visible={visible} />
    </>
  );
}
